import { useEffect } from 'react'
import { isEmpty } from 'lodash'
import { createSearchParams, useLocation, useNavigate } from 'react-router-dom'

export const useQueryParamsDefaults = (
  defaultParams = { page: 1, per_page: 10 }
) => {
  const location = useLocation()
  const navigate = useNavigate()
  const DEFAULT_PAGE = 1
  const DEFAULT_PER_PAGE = 10
  useEffect(() => {
    const page = defaultParams.page || DEFAULT_PAGE
    const perPage = defaultParams.per_page || DEFAULT_PER_PAGE

    const searchParams = createSearchParams({
      page,
      per_page: perPage,
      ...defaultParams
    })

    const currentSearchParams = new URLSearchParams(location.search)

    let paramsChanged = false

    // Verifica y establece los valores predeterminados si no están presentes en los parámetros de búsqueda
    Object.entries(defaultParams).forEach(([key, value]) => {
      if (isEmpty(currentSearchParams.get(key))) {
        searchParams.set(key, value)
        paramsChanged = true
      }
    })

    // Actualiza la URL si se cambiaron los parámetros
    if (paramsChanged) {
      navigate(`?${searchParams.toString()}`, { replace: true })
    }
  }, [location.search])
}
